import { gql } from '@apollo/client';

import { FragmentAccessoryPDP } from '../../fragments/accessories/pdp';

export const GET_ACCESSORY_BRANDS = gql`
  query GET_ACCESSORY_BRANDS {
    accessoryBrands {
      name
      dealerId
      distributorId
    }
  }
`;

export const GET_ACCESSORY_MODELS = gql`
  query GET_ACCESSORY_MODELS($distributorId: String!) {
    accessoryModelsVariants(distributorId: $distributorId) {
      image
      model
      variants
    }
  }
`;

export const GET_ACCESSORY_CATEGORIES = gql`
  query GET_ACCESSORY_CATEGORIES($filter: AccessoryFilterOptions!) {
    accessoryCategories(filter: $filter) {
      id
      name
      count
      ownCount
      image
    }
  }
`;

export const GET_ACCESSORIES = gql`
  query GET_ACCESSORIES(
    $filter: AccessorySearchOptions!
    $sorting: AccessorySortingOptions
  ) {
    accessorySearch(filter: $filter, sorting: $sorting) {
      sku
      productId
      title
      specification
      unitPrice
      sumPrice
      images {
        url
        id
      }
      carLines
    }
  }
`;

export const GET_ACCESSORY_BY_ID = gql`
  query GET_ACCESSORY_BY_ID(
    $filter: AccessoryFilterOptions!
    $accessoryId: String!
  ) {
    ...FragmentAccessoryPDP
  }
  ${FragmentAccessoryPDP}
`;

export const GET_ACCESSORY_PRICE_DETAILS = gql`
  query GET_ACCESSORY_PRICE_DETAILS($dealerId: String!, $productId: String!) {
    accessoryPriceDetails(dealerId: $dealerId, productId: $productId) {
      productId
      catalogProductId
      price
      shippingOptions {
        sku
        title
        shippingType
        price
        priceDimension
      }
    }
  }
`;
